import { MESSAGE } from './constant';
import useFeatureFlag from './useFeatureFlag';
import useIsFeatureDisabled from './useIsFeatureDisabled';

export default useFeatureFlag;

export { MESSAGE, useIsFeatureDisabled };
